import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

import RecentAssessmentItem from './RecentAssessmentItem';

function RecentAssessments({ assessments, sections, users, currentUser }) {
  const sortedAssessments = Object.values(assessments)
    .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
  return (
    // This is a bit of a strange layout, but it's to force alignment with the dashboard sidebar
    <Fragment>
      <div className="recent-assessments__header">
        <h2 className="recent-assessments__heading">Recent Assessments:</h2>
      </div>
      <div className="recent-assessments">
        {[...Array(3).keys()].map((number) => {
          // Only show the latest four assessments
          if (!sortedAssessments[number]) return null;
          const item = sortedAssessments[number];
          return (
            <RecentAssessmentItem
              key={item.id}
              item={item}
              section={sections[item.section]}
              user={users[item.lastEditedBy] || null}
              currentUser={currentUser}
            />
          );
        })}
        <div className="recent-assessments__button-wrapper">
          <Link to="/assessments" className="button button--blue-outline">
            View All Assessments
          </Link>
        </div>
      </div>
    </Fragment>
  );
}

export default RecentAssessments;



// WEBPACK FOOTER //
// ./src/components/features/dashboard/RecentAssessments.js